import { Box, InputGroup, InputLeftElement, Input, IconButton,  Menu, MenuButton, MenuList, MenuItem,  useToast,
Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, DrawerCloseButton,Modal,
ModalContent, Tooltip,Portal,
ModalHeader,Text,
ModalFooter,
ModalBody,Spacer,
ModalCloseButton,  Divider, Icon} from "@chakra-ui/react";
import { SearchIcon,CheckIcon } from "@chakra-ui/icons";
import { MdFilterAlt, MdFilterAltOff,MdInfo,MdOutlineArticle,MdPrint } from "react-icons/md";
import {RiFileExcel2Fill} from "react-icons/ri"
import ComponentHeader from "../main/ComponentHeader";
import GruntComponents from '../components';
import { useState, useEffect,useRef } from "react";
import { getAllMigracije, getRegistarPdf } from "../../util/apiRegistar";
import RegistarTable from "./RegistarTableV1";
import MigracijaCard from "./MigracijaCard";
import RegistarFilter from "./RegistarFilter";
import { RegistarFilterTypes } from "./RegistarFilter";
import { getLokacijeForTreeView } from "../../util/apiLokacija";
//import RegistarIspisFilter from "./RegistarIspisFilter";
import RegistarFilterInfo from "./RegistarFilterInfo";
import GovedoView from "../govedo/GovedoView";
import { updateGovedo } from "../../util/apiGovedo";


export default function Registar({onClosePress}) {
    const [ispis,setIspis]=useState({izvj:"",params:{}});
    const [filter, setFilter] = useState({filterInfoShow:false,filterActive:false,quickFilterType:'zivbr',quickFilter:"",showFilterControl:false,showKnjigeFilter:false,filterType:RegistarFilterTypes.BezFiltera,toggleFetchData:false});
    const [filterStanjeNaDan,setFilterStanjeNaDan]=useState(new Date().toISOString().split('T')[0]);
    const [selectedknjige,setSelectedKnjige]=useState([]);
    const [selectedposjednici,setSelectedPosjednici]=useState([]);
    const [selectedpasmine,setSelectedPasmine]=useState([]);
    const [otislasgospodarstva,setOtislaSGospodarstva]=useState(false);
    const [selectedlokacije,setSelectedLokacije]=useState([]);
    const [dolTipPeriodFilterValue,setDolTipPeriodFilterValue]=useState({});
    const [odlTipPeriodFilterValue,setOdlTipPeriodFilterValue]=useState({});
    const [tovFilterValue,setTovFilterValue]=useState({});
    const [tovDatumiFilterValue,setTovDatumiFilterValue]=useState({});
    const [rodDatumiFilterValue,setRodDatumiFilterValue]=useState({});
    const [spolFilterValue,setSpolFilterValue]=useState("");
    const [dataisloading,setDataIsLoading]=useState(true);
    //const [RegistarIspisFilterState,setRegistarIspisFilterState]=useState({showFilterIspis:false,godine:[],knjige:[],selectedGodina:0,selectedKnjigaid:0});;
    //const [toggleFetchData,setToggleFetchData]=useState(false);
    const [data,setData]=useState({data:[],totalrowscount:0,orderbycol:"",orderby:"desc"});
    const [err,setErr]=useState("");
    const [info,setInfo]=useState("");
    const [MigracijaToShow,setMigracijaToShow]=useState({govedoid:0,dolmigid:0,dolmigsif:"",odlmigid:0,odlmigsif:""});
    const [govedoforedit,setGovedoForEdit]=useState(0);
    const toast=useToast();
    const [lokacije,setLokacije]=useState([]);

    const srchGrloRef=useRef(null);

    
useEffect(()=>{
  const fetchLokacije=async()=>{
    try {
      const _res=await getLokacijeForTreeView();
      if (_res.status===200) {
        setLokacije(_res.res);
      } else {
        throw new Error(_res.message);
      }
    } catch (error) {
      setErr(error.message);
    }
  }
  
  

  

  fetchLokacije();
  
  
},[])

useEffect(() => {

  const fetchData=async()=>{
    try {
      setErr("");
      const _queryparams={};
      if (ispis.izvj==="fip1"  ) {
        _queryparams._pdf1=true;
        _queryparams._pdf2=false;
      } else if (ispis.izvj==="fip2") {
        _queryparams._pdf1=false;
        _queryparams._pdf2=true;
      } else {
        _queryparams._pdf1=false;
        _queryparams._pdf2=false;
      }
      //********
      if (ispis.izvj==="fipxlsx") {
        _queryparams._xlsx=true;
      } else {
        _queryparams._xlsx=false;
      }
      //********
      if (!_queryparams._pdf1 && !_queryparams._pdf2 && !_queryparams._xlsx) {
        setDataIsLoading(true);
      }
      if (selectedknjige.length>0) {
        _queryparams._knjige=selectedknjige;
      }
      //pasmine
      if (selectedpasmine.length>0) {
        _queryparams._pasmine=selectedpasmine;
      }
      if (selectedposjednici.length>0) {
        _queryparams._posjednici=selectedposjednici;
      }
      if (selectedlokacije.length>0) {
        _queryparams._lokacije=selectedlokacije;
      }
      if (filterStanjeNaDan!=="") {
        _queryparams._stanjenadan=filterStanjeNaDan;
      }
      if (spolFilterValue!=="") {
        _queryparams._spol=spolFilterValue;
      }
      if (otislasgospodarstva) {
        _queryparams._otislasgospodarstva='true';
      }
      if (Object.getOwnPropertyNames(dolTipPeriodFilterValue).length!==0) {
        _queryparams._doltipperiod='true';
        if (dolTipPeriodFilterValue.filterbymigracije===false) {
          _queryparams._doltipperiod_datod=dolTipPeriodFilterValue.datod;
          _queryparams._doltipperiod_datdo=dolTipPeriodFilterValue.datdo;
          _queryparams._doltipperiod_duvoz=dolTipPeriodFilterValue.duvoz;
          _queryparams._doltipperiod_dtelj=dolTipPeriodFilterValue.dtelj;
          _queryparams._doltipperiod_dkup=dolTipPeriodFilterValue.dkup;
          
          if (dolTipPeriodFilterValue.prijasnji_posjednik_knjiga!=="-1") {
              _queryparams._doltipperiod_posjednik_knjiga=dolTipPeriodFilterValue.posjednik_knjiga;
              _queryparams._doltipperiod_prijasnji_posjednik_knjiga=dolTipPeriodFilterValue.prijasnji_posjednik_knjiga;  
          }
      } else {
        _queryparams._doltipperiod_migracijeid=dolTipPeriodFilterValue.migracijeid;
      }
      }

      if (Object.getOwnPropertyNames(odlTipPeriodFilterValue).length!==0) {
        _queryparams._odltipperiod='true';
        if (odlTipPeriodFilterValue.filterbymigracije===false) {
          _queryparams._odltipperiod_datod=odlTipPeriodFilterValue.datod;
        _queryparams._odltipperiod_datdo=odlTipPeriodFilterValue.datdo;
        
        if (odlTipPeriodFilterValue.novi_posjednik_knjiga!=="-1") {
          _queryparams._odltipperiod_posjednik_knjiga=odlTipPeriodFilterValue.posjednik_knjiga;
          _queryparams._odltipperiod_novi_posjednik_knjiga=odlTipPeriodFilterValue.novi_posjednik_knjiga;
        }
        const _ar=[];
          if (odlTipPeriodFilterValue.oprod) {
            _ar.push("OPROD");
          }
          if (odlTipPeriodFilterValue.omik) {
            _ar.push("OMIK");
          }
          if (odlTipPeriodFilterValue.okla) {
            _ar.push("OKLA");
          }
          if (odlTipPeriodFilterValue.oizvz) {
            _ar.push("OIZVZ");
          }
          if (odlTipPeriodFilterValue.oizgb) {
            _ar.push("OIZGB");
          }
          if (odlTipPeriodFilterValue.ougin) {
            _ar.push("OUGIN");
          }
          if (_ar.length===0) {
            _ar.push("OPROD");
            _ar.push("OMIK");
            _ar.push("OKLA");
            _ar.push("OIZVZ");
            _ar.push("OIZGB");
            _ar.push("OUGIN");
          }
          _queryparams._odltipperiod_odltipids=_ar;
        } else {
          _queryparams._odltipperiod_migracijeid=odlTipPeriodFilterValue.migracijeid;
        }
        
      }
      
      
      //tov
      if (Object.getOwnPropertyNames(tovFilterValue).length!==0) {
        _queryparams._tovdaniod=tovFilterValue.min;
        _queryparams._tovdanido=tovFilterValue.max;
      }
      //tov datumi
      if (Object.getOwnPropertyNames(tovDatumiFilterValue).length!==0) {
        _queryparams._tovdatod=tovDatumiFilterValue.datod;
        _queryparams._tovdatdo=tovDatumiFilterValue.datdo;
      }
      //rod datumi
      if (Object.getOwnPropertyNames(rodDatumiFilterValue).length!==0) {
        _queryparams._roddatod=rodDatumiFilterValue.datod;
        _queryparams._roddatdo=rodDatumiFilterValue.datdo;
      }
      //zivbr
      if (filter.quickFilterType==="zivbr" && filter.quickFilter!=="") {
        _queryparams._zivbr=filter.quickFilter;
      }
      //rfid
      if (filter.quickFilterType==="rfid" && filter.quickFilter!=="") {
        _queryparams._rfid=filter.quickFilter;
      }
      //oznaka na putnici
      if (filter.quickFilterType==="oznput" && filter.quickFilter!=="" && !isNaN(filter.quickFilter)) {
        _queryparams._oznput=filter.quickFilter;
      }
      //pasmine
    
     
     
      const _res=await getAllMigracije(_queryparams);
      if (_res.status===200) {
      
        if (ispis.izvj==="fip1" || ispis.izvj==="fip2") {
          
          const file = new Blob([_res.res], { type: "application/pdf" });
          
      
          //const fileURL = URL.createObjectURL(file);
      
          //const pdfWindow = window.open(fileURL,'_blank');
          const url = window.URL.createObjectURL(file);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "Report.pdf";
            a.click();
            window.URL.revokeObjectURL(url);


       
       
        } else if(ispis.izvj==="fipxlsx") {
            //const buffer = Buffer.from(_res.res);
            const blob = new Blob([_res.res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                      
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "filename.xlsx";
            a.click();
            window.URL.revokeObjectURL(url);
            
        }else {
          //ako je lokalni filter onda treba podatke provući kroz syncQuickFilter, ako su se podaci već
          //filtrirano povukli sa servera onda ne treba
          setData({...data,data:_res.res.data,odrezano:_res.res.odrezano});
        }
        setIspis({...ispis,izvj:"",params:{}});
        
      } else {
        throw new Error(_res.message);
      }
    } catch (error) {
      setErr("Greška:" + error.message);
      //setIspis({...ispis,izvj:"",params:{}});
    } finally {
      setDataIsLoading(false);
    }
} 
      fetchData();
   

    
  
}, [filter.toggleFetchData])

useEffect(()=>{
  const fetchRegistarPdf=async()=>{
    try {
      const _res=await getRegistarPdf(ispis.params.godina,ispis.params.knjigaid);
      if (_res.status===200) {
          setIspis({...ispis,izvj:"",params:{}});
      } else {
        throw new Error(_res.message);
      }
    } catch (error) {
      setIspis({...ispis,izvj:"",params:{}});
      setErr(error.message);
    }
  }

  if (ispis.izvj==="rgg") {
    fetchRegistarPdf();
  }
  
},[ispis.izvj])

const showErr=()=>{
  if (err!=="") {
    setErr("");
    return(
    toast({
      title:"Greška",
      status:"error",
      description:err,
      isClosable:true,
      duration:5000,
      position:"top-right",
  }));
  
  }
}

const showInfo=()=>{
  if (info!=="") {
    setInfo("");
    return(
    toast({
      title:"Podatak ažuriran",
      status:"success",
      description:info,
      isClosable:true,
      duration:5000,
      position:"top-right",
  }));
  
  }
}


  const onCloseFilter=()=>{

    setFilter({...filter,showFilterControl:false,showKnjigeFilter:false});
    
  }

  const setSelectedMigracija=(_govedoid,_dolmigid,_dolmigsif,_odlmigid=0,_odlmigsif="")=>{
    setMigracijaToShow({govedoid:_govedoid,dolmigid:_dolmigid,dolmigsif:_dolmigsif,odlmigid:_odlmigid,odlmigsif:_odlmigsif});
  }

  const closeSelectedMigracija=()=>{
    setMigracijaToShow({govedoid:0,dolmigid:0,dolmigsif:"",odlmigid:0,odlmigsif:""});
  }

  const showSelectedMigracija=()=>{
    if (MigracijaToShow.govedoid!==0) {
      return (
        <Drawer placement='right' size={'lg'} isOpen={true} onClose={closeSelectedMigracija}>
        <DrawerOverlay/>
        <DrawerContent>
        <DrawerCloseButton color={'white'}/>
            <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                Pregled podataka migracije/goveda
            </DrawerHeader>
            <DrawerBody>
                <MigracijaCard onClose={closeMigracijaCard} govedoid={MigracijaToShow.govedoid} dolmigrid={MigracijaToShow.dolmigid} odlmigrid={MigracijaToShow.odlmigid} dolmigsif={MigracijaToShow.dolmigsif} odlmigsif={MigracijaToShow.odlmigsif}/>                    
            </DrawerBody>
        </DrawerContent>
        </Drawer>
    )
    }
  }

  const closeMigracijaCard=()=>{
    setMigracijaToShow({...MigracijaToShow,govedoid:0});
  }

  const getFilterControl=()=>{
    if (filter.showFilterControl) {
      let filterVal=null;
      if (filter.filterType===RegistarFilterTypes.StanjeNaDan && filterStanjeNaDan!=="") {
        filterVal=filterStanjeNaDan;
      } else if (filter.filterType===RegistarFilterTypes.TovDani && Object.getOwnPropertyNames(tovFilterValue).length!==0) {
        filterVal=tovFilterValue;
      } else if (filter.filterType===RegistarFilterTypes.TovDatumi && Object.getOwnPropertyNames(tovDatumiFilterValue).length!==0) {
        filterVal=tovDatumiFilterValue;
      } else if (filter.filterType===RegistarFilterTypes.RodDatumi && Object.getOwnPropertyNames(rodDatumiFilterValue).length!==0) {
        filterVal=rodDatumiFilterValue;
      } else if (filter.filterType===RegistarFilterTypes.OdlasciTipPeriod && Object.getOwnPropertyNames(odlTipPeriodFilterValue).length!==0) {
        filterVal=odlTipPeriodFilterValue;
      } else if (filter.filterType===RegistarFilterTypes.DolasciTipPeriod && Object.getOwnPropertyNames(dolTipPeriodFilterValue).length!==0) {
        filterVal=dolTipPeriodFilterValue;
      }else if (filter.filterType===RegistarFilterTypes.Lokacije && selectedlokacije.length>0) {
        filterVal=selectedlokacije;
      } else if (filter.filterType===RegistarFilterTypes.Spol && spolFilterValue!=="") {
        filterVal=spolFilterValue;
      } else if (filter.filterType===RegistarFilterTypes.Pasmine && selectedpasmine.length>0){
        filterVal=selectedpasmine;
      }
      return (
        <Modal isOpen={true} onClose={onCloseFilter} closeOnOverlayClick={false} size={filter.filterType.size} colorScheme="grunt2">
        <ModalContent shadow={'dark-lg'}>
          <ModalHeader bgColor={'gray.100'} color={'grunt2.600'}>
            {filter.filterType.naslov}
          </ModalHeader>
          <ModalCloseButton size={'sm'} />
          <ModalBody>
            <RegistarFilter filterValue={filterVal} onClose={onCloseFilter} onClear={onClearFilterValue} selectedPosjednici={selectedposjednici} selectedKnjige={selectedknjige} registerfiltertype={filter.filterType} onSetFilter={onSetFilterValue} lokacije={lokacije} selectedQuickFilterTypes={filter.quickFilterType}/>
            
          </ModalBody>

          <ModalFooter>
            
            
          </ModalFooter>
        </ModalContent>
      </Modal>
      )
    }
    
  }

  

  const onSelectKnjige=(knj)=>{
    setDataIsLoading(true);
    setSelectedKnjige(knj);
    setSelectedPosjednici([])
    setFilter({...filter,showFilterControl:false,showKnjigeFilter:false,showPosjedniciFilter:false,filterType:RegistarFilterTypes.BezFiltera,toggleFetchData:!filter.toggleFetchData});
    //setToggleFetchData(!toggleFetchData);
  }
const onClearFilterKnjige=()=>{
  setDataIsLoading(true);
  setSelectedKnjige([]);
  
  setFilter({...filter,showFilterControl:false,showKnjigeFilter:false,showPosjedniciFilter:false,filterType:RegistarFilterTypes.BezFiltera,toggleFetchData:!filter.toggleFetchData});
}
  
const onClearFilterValue=()=>{
  if (filter.filterType.sif===RegistarFilterTypes.StanjeNaDan.sif) {
    setFilterStanjeNaDan("");
    
  } else if (filter.filterType.sif===RegistarFilterTypes.Lokacije.sif){
    setSelectedLokacije([]);
    
  } else if (filter.filterType.sif===RegistarFilterTypes.BrzaPretraga.sif){
    return;
  } else if (filter.filterType.sif===RegistarFilterTypes.Posjednici.sif){
    setSelectedPosjednici([]);
    
    
  } else if (filter.filterType.sif===RegistarFilterTypes.DolasciTipPeriod.sif) {
    setDolTipPeriodFilterValue({});
    
  } else if (filter.filterType.sif===RegistarFilterTypes.OdlasciTipPeriod.sif) {
    setOdlTipPeriodFilterValue({});
    
  } else if (filter.filterType.sif===RegistarFilterTypes.TovDani.sif) {
    setTovFilterValue({});
  } else if (filter.filterType.sif===RegistarFilterTypes.TovDatumi.sif) {
    setTovDatumiFilterValue({});
  } else if (filter.filterType.sif===RegistarFilterTypes.RodDatumi.sif) {
    setRodDatumiFilterValue({});
  } else if (filter.filterType.sif===RegistarFilterTypes.Spol.sif) {
    setSpolFilterValue("");
  } else if (filter.filterType.sif===RegistarFilterTypes.Pasmine.sif){
    setSelectedPasmine([]);
  }

  setDataIsLoading(true);
  setFilter({...filter,showFilterControl:false,showKnjigeFilter:false,toggleFetchData:!filter.toggleFetchData});
}
  const onSetFilterValue=(val)=>{
    
    let _fetchdata=true;
    let _qft=filter.quickFilterType;
    let _filteractive=filter.filterActive;
    if (filter.filterType.sif===RegistarFilterTypes.StanjeNaDan.sif) {
      setFilterStanjeNaDan(val);
      setOtislaSGospodarstva(false);
      //setDolTipPeriodFilterValue({});
      setOdlTipPeriodFilterValue({});
      _filteractive=true;
    } else if (filter.filterType.sif===RegistarFilterTypes.Lokacije.sif){
      setSelectedLokacije(val);
      _filteractive=true;
    } else if (filter.filterType.sif===RegistarFilterTypes.BrzaPretraga.sif){
      _qft=val;
      _fetchdata=false;
    } else if (filter.filterType.sif===RegistarFilterTypes.Posjednici.sif){
      setSelectedPosjednici(val);
      setSelectedKnjige([]);
      _filteractive=true;
    } else if (filter.filterType.sif===RegistarFilterTypes.DolasciTipPeriod.sif) {
      setDolTipPeriodFilterValue(val);
      //setOdlTipPeriodFilterValue({});
      setOtislaSGospodarstva(false);
      //setFilterStanjeNaDan("");
      _filteractive=true;
    } else if (filter.filterType.sif===RegistarFilterTypes.OdlasciTipPeriod.sif) {
      setOdlTipPeriodFilterValue(val);
      //setDolTipPeriodFilterValue({});
      setOtislaSGospodarstva(false);
      setFilterStanjeNaDan("");
      _filteractive=true;
    } else if (filter.filterType.sif===RegistarFilterTypes.TovDani.sif) {
      setTovFilterValue(val);
      _filteractive=true;
    } else if (filter.filterType.sif===RegistarFilterTypes.TovDatumi.sif) {
      setTovDatumiFilterValue(val);
      _filteractive=true;
    }  else if (filter.filterType.sif===RegistarFilterTypes.RodDatumi.sif) {
      setRodDatumiFilterValue(val);
      _filteractive=true;
    } else if (filter.filterType.sif===RegistarFilterTypes.Spol.sif) {
      if (val!=="f" && val!=="m") {
        val="";
      }
      setSpolFilterValue(val);
      _filteractive=true;
    } else if (filter.filterType.sif===RegistarFilterTypes.Pasmine.sif) {
      setSelectedPasmine(val);
      _filteractive=true;
    }

    //setStateFilterValue(val);
    if (_fetchdata) {
      setDataIsLoading(true);
      setFilter({...filter,filterActive:_filteractive,showFilterControl:false,showKnjigeFilter:false,toggleFetchData:!filter.toggleFetchData,quickFIlterType:_qft});      
    } else {//samo postavi postavke brzog filtera
      setFilter({...filter,showFilterControl:false,quickFilterType:_qft,quickFilter:""});      
    }
    
  }

  

  const getKnjigeFilter=()=>{
    if (filter.showKnjigeFilter) {
      return (
      <Modal isOpen={true} onClose={onCloseFilter} closeOnOverlayClick={false} size={'xs'}>
      <ModalContent shadow={'dark-lg'}>
      <ModalHeader bgColor={'gray.100'} color={'grunt2.600'} h={'20px'}>
          Knjige
        </ModalHeader>
        <ModalCloseButton size={'sm'} />
        <ModalBody>
          <RegistarFilter onClose={onCloseFilter} onClear={onClearFilterKnjige} onSetFilter={onSelectKnjige} selectedKnjige={selectedknjige} registerfiltertype={RegistarFilterTypes.Knjige} /> 
          
        </ModalBody>

        <ModalFooter>
          
          
        </ModalFooter>
      </ModalContent>
      </Modal>
    )
    }
  }
  
const onOrderByChange=(val)=>{
  const _ar=data.data;
  //const _currdat=new Date();
  let _i;
  if (val.column==="knjiga") {
    _ar.sort((a,b)=>{
      _i = a.knjiga.localeCompare(b.knjiga,'hr');
      return val.asc?_i*-1:_i;
    })
  } else if (val.column==="posjednik"){
    _ar.sort((a,b)=>{
      _i = a.pos1.localeCompare(b.pos1,'hr');
      return val.asc?_i*-1:_i;
    })
  } else if (val.column==="pasmina") {
    _ar.sort((a,b)=>{
      _i = a.pasmina.localeCompare(b.pasmina,'hr');
      return val.asc?_i*-1:_i;
    })
  } else if (val.column==="zivbr") {
    _ar.sort((a,b)=>{
      _i = a.zivbr.localeCompare(b.zivbr,'hr');
      return val.asc?_i*-1:_i;
    })
  } else if (val.column==="spol") {
    _ar.sort((a,b)=>{
      _i = a.spol.localeCompare(b.spol,'hr');
      return val.asc?_i:_i*-1;
    })
  } else if (val.column==="datum_rodjenje") {
    _ar.sort((a,b)=>{
      _i=a.datum_rodjenje>b.datum_rodjenje?1:-1;
      return val.asc?_i*-1:_i;
    })
  } else if (val.column==="dol_datum") {
    _ar.sort((a,b)=>{
      _i=a.dol_datum>b.dol_datum?1:-1;
      return val.asc?_i*-1:_i;
    })
  } else if (val.column==="odl_datum") {
    _ar.sort((a,b)=>{
      //_i=a.odl_datum===null?_currdat:a.odl_datum>=b.odl_datum===null?_currdat:b.odl_datum?1:-1;
      if (a.odl_datum===null && b.odl_datum!==null) {
        _i=-1;
      } else if (a.odl_datum!==null && b.odl_datum===null) {
        _i=1
      } else if (a.odl_datum===null && b.odl_datum===null) {
        _i=0;
      } else {
        _i=a.odl_datum>b.odl_datum?1:-1;
      }
      
      return val.asc?_i*-1:_i;
    })
  } else if (val.column==="rfid") {
    _ar.sort((a,b)=>{
      _i = a.rfid.localeCompare(b.rfid,'hr');
      return val.asc?_i*-1:_i;
    })
  } else if (val.column==="putnica_oznaka") {
    _ar.sort((a,b)=>{
      _i = a.putnica_oznaka>=b.putnica_oznaka?1:-1;
      return val.asc?_i*-1:_i;
    })
  } else if (val.column==="dani_u_tovu") {
    _ar.sort((a,b)=>{
      _i = a.dani_u_tovu>=b.dani_u_tovu?1:-1;
      return val.asc?_i*-1:_i;
    })
  }

  setData({...data,data:_ar});
}

  const showData=()=>{
    /*if (dataisloading) {
        return (
          <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%' h={'100%'}>
                    <SkeletonCircle size='10' />
                    <SkeletonText mt='4' noOfLines={30} spacing='4' skeletonHeight='2' />
              </Box>
        )
    } else {*/
     
        return (
          <RegistarTable data={data.data} onEditGovedo={onEditGovedoEvent} onShowItem={setSelectedMigracija} onOrderBy={onOrderByChange} odrezano={data.odrezano} dataIsLoading={dataisloading}/>
        )
    //}
    
  }
  
  const onEditGovedoEvent=(govedoid)=>{
    setGovedoForEdit(govedoid);
  }

  const showGovedoForEdit=()=>{
    if (govedoforedit!==0) {
      return (
        <Drawer placement='right' size={'md'} isOpen={true} onClose={closeSelectedMigracija}>
        <DrawerOverlay/>
        <DrawerContent>
        <DrawerCloseButton onClick={()=>{setGovedoForEdit(0)}}/>
            <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                Ispravak podataka goveda
            </DrawerHeader>
            <DrawerBody>
                <GovedoView _idgoveda={govedoforedit} _readonly={false} onClose={()=>{setGovedoForEdit(0)}} _showSaveClose={true} onSave={saveEditedGovedo}/>
            </DrawerBody>
        </DrawerContent>
        </Drawer>
      )
    }
  }

  const saveEditedGovedo=async (data)=>{
    
    try {
      const _res=await updateGovedo({govedo:data})
      if (_res.status===200) {
        setFilter({...filter,toggleFetchData:!filter.toggleFetchData});
        setGovedoForEdit(0);
        setInfo("Podaci goveda ažurirani.")
      } else {
        throw new Error(_res.message);
      }
    } catch (error) {
      setErr(error.message);
    }
  }

  const showKnjigeFilter=()=>{
    setFilter({...filter,showKnjigeFilter:true});
  }


  const showFilter=(filtertype)=>{
    
    setFilter({...filter,showKnjigeFilter:false,showFilterControl:true,filterType:filtertype});
    if (filtertype.sif===RegistarFilterTypes.OtislaSGospodarstva.sif) {
      setFilterStanjeNaDan("");
      setDataIsLoading(true);
      setOtislaSGospodarstva(!otislasgospodarstva);
      setOdlTipPeriodFilterValue({});
      setDolTipPeriodFilterValue({});
      setFilter({...filter,filterActive:true,filterType:filtertype,toggleFetchData:!filter.toggleFetchData});    
      //setToggleFetchData(!toggleFetchData);
    }
    
  }

 

  const resetFilterAll=()=>{
    setDataIsLoading(true);
    //setFilter({...filter,quickFilter:"",showKnjigeFilter:false,showFilterControl:false,filterActive:false,filterType:RegistarFilterTypes.BezFiltera,toggleFetchData:!filter.toggleFetchData});
    setFilter({...filter,quickFilter:"",showKnjigeFilter:false,showFilterControl:false,filterActive:false,filterType:RegistarFilterTypes.StanjeNaDan,toggleFetchData:!filter.toggleFetchData});

    setSelectedKnjige([]);
    setSelectedLokacije([]);
    setSelectedPosjednici([]);
    setFilterStanjeNaDan(new Date().toISOString().split('T')[0]);
    setDolTipPeriodFilterValue({});
    setOdlTipPeriodFilterValue({});
    setTovFilterValue({});
    setTovDatumiFilterValue({});
    setRodDatumiFilterValue({});
    setSpolFilterValue("");
    setOtislaSGospodarstva(false);
    setSelectedPasmine([]);
    
    
    //setToggleFetchData(!toggleFetchData);
  }
  
  const onQuickFilter=(event)=>{
    //ako je postavljena putnica oznaka prihvaćaj samo integer
    let _rgxstr="";
    let _test=false;
    const _s=event.target.value;
    if (filter.quickFilterType==="oznput") {
      //samo brojevi
      _rgxstr="^[0-9]*$"
    } else if (filter.quickFilterType==="rfid"){
      _rgxstr="^(\\*?[0-9]*\\*?)*$"
    } else if (filter.quickFilterType==="zivbr") {
      _test=true;
    }
    if (!_test) {
      const _r=new RegExp(_rgxstr);
      _test=_r.test(_s);
    }
    if (_test) {
      setFilter({...filter,quickFilter:_s});  
    }
    
  }

  const onQuickFilterKeyDown=(event)=>{
    if (event.which===13) {//enter
      //resetFilterExceptQuickSearch();
      setFilter({...filter,filterActive:true,toggleFetchData:!filter.toggleFetchData/*,filterType:RegistarFilterTypes.BezFiltera*/}); 
      srchGrloRef.current.focus();
      srchGrloRef.current.select();   
    }
    //ako je postavljen rfid ili samo putnica oznaka dopusti samo slova
    

  }

  const filterInfoShow=()=>{
    if (filter.filterInfoShow) {
      return (
        <Modal isOpen={true} closeOnOverlayClick={false} size={'md'} colorScheme="blue" onClose={()=>{setFilter({...filter,filterInfoShow:false})}}>
          <ModalContent shadow={'dark-lg'}>
            <ModalHeader bgColor={'gray.100'} color={'grunt2.600'} fontSize={'sm'}>
              Aktivni filteri
            </ModalHeader>
            <ModalCloseButton size={'sm'}/>
            <ModalBody>
                <RegistarFilterInfo size="xs" _knjige={selectedknjige} _posjednici={selectedposjednici} _stanjenadan={filterStanjeNaDan} _spol={spolFilterValue} _pasmine={selectedpasmine}
                _doltipperiod={dolTipPeriodFilterValue} _odltipperiod={odlTipPeriodFilterValue} _napustilagospodarstvo={otislasgospodarstva} _tovdani={tovFilterValue} _tovdatumi={tovDatumiFilterValue} _roddatumi={rodDatumiFilterValue} _lokacije={selectedlokacije} />
              
            </ModalBody>
  
            <ModalFooter>
              
              
            </ModalFooter>
          </ModalContent>
        </Modal>
        )  
    }
    
  }
  const getSearchBoxPlaceHolder=()=>{
    let s= ""
    if (filter.quickFilterType==="zivbr") {
      s=s+"životni broj"
    } 
    if (filter.quickFilterType==="rfid") {
      s=s+"rfid"
    }
    if (filter.quickFilterType==="oznput") {
      s=s+"oznaka na putnici"
    }
    
    return "Brza pretraga: " + s;
  }
  return (
    <Box h={'100%'} display={'flex'} flexDir={'column'} flex={1} key='odlasci_component' pl='0.5rem' pr={'0.5rem'} /* pb={'0.2rem'} borderWidth={'1px'} borderColor={'silver'} */ borderBottomRightRadius={'md'}>
    <ComponentHeader onClosePress={onClosePress} component={GruntComponents.Registar}/>
    <Box  display={'flex'} alignItems={'center'}  mb={'0.5rem'} >
              <Box mr={'0.5rem'} display={'flex'} flexDir={'row'}>
                <InputGroup size={'xs'} w='20rem'>
                    <InputLeftElement pointerEvents={'none'} children={<SearchIcon/>}/>
                    <Input ref={srchGrloRef} focusBorderColor='grunt2.400' maxLength={filter.quickFilterType!=="oznput"?20:9} textTransform={'uppercase'} placeholder={getSearchBoxPlaceHolder()} value={filter.quickFilter}  onChange={onQuickFilter} onKeyDown={onQuickFilterKeyDown} textAlign={'right'} />
                </InputGroup>
                
                </Box>
                <Divider orientation="vertical"/>
                 <Menu>
                 <Tooltip label={'Filter'}>
                    <MenuButton
                      as={IconButton}
                      aria-label='Options'
                      icon={<MdFilterAlt/>}
                      variant={filter.filterActive | selectedknjige.length>0?'solid':'outline'}
                      colorScheme={'grunt2'}
                      size={'xs'}
                    />
                  </Tooltip>
                  <Portal>
                    <MenuList zIndex={1400}>
                      <MenuItem fontSize={'xs'} onClick={()=>{showFilter(RegistarFilterTypes.Posjednici)}}>
                        {selectedposjednici.length!==0?<><Text>Posjednici</Text><Spacer/><CheckIcon/></>:<Text>Posjednici</Text>}
                      </MenuItem>
                      <MenuItem fontSize={'xs'} onClick={()=>showKnjigeFilter()}>
                        {selectedknjige.length===0?<Text>Knjige</Text>:<><Text>Knjige</Text><Spacer/><CheckIcon/></>}
                      </MenuItem>
                      <Divider/>
                      <MenuItem fontSize={'xs'} onClick={()=>{showFilter(RegistarFilterTypes.StanjeNaDan)}}>
                        {filterStanjeNaDan!==""?<><Text>Stanje na dan</Text><Spacer/><CheckIcon/></>:<Text>Stanje na dan</Text>}
                      </MenuItem>
                      <MenuItem fontSize={'xs'} onClick={()=>{showFilter(RegistarFilterTypes.OtislaSGospodarstva)}}>
                        {otislasgospodarstva?<><Text>Napustila gospodarstvo</Text><Spacer/><CheckIcon/></>:<Text>Napustila gospodarstvo</Text>}
                      </MenuItem>
                      <MenuItem fontSize={'xs'} onClick={()=>{showFilter(RegistarFilterTypes.DolasciTipPeriod)}}>
                        {Object.getOwnPropertyNames(dolTipPeriodFilterValue).length!==0?<><Text>Dolasci po tipu i periodu</Text><Spacer/><CheckIcon/></>:<Text>Dolasci po tipu i periodu</Text>}
                      </MenuItem>
                      <MenuItem fontSize={'xs'} onClick={()=>{showFilter(RegistarFilterTypes.OdlasciTipPeriod)}}>
                        {Object.getOwnPropertyNames(odlTipPeriodFilterValue).length!==0?<><Text>Odlasci po tipu i periodu</Text><Spacer/><CheckIcon/></>:<Text>Odlasci po tipu i periodu</Text>}
                      </MenuItem>
                      <Divider/>
                      <MenuItem fontSize={'xs'} onClick={()=>{showFilter(RegistarFilterTypes.TovDani)}}>
                        {Object.getOwnPropertyNames(tovFilterValue).length!==0?<><Text>Dani tova</Text><Spacer/><CheckIcon /></>:<Text>Dani tova</Text>}
                      </MenuItem>
                      <MenuItem fontSize={'xs'} onClick={()=>{showFilter(RegistarFilterTypes.TovDatumi)}}>
                        {Object.getOwnPropertyNames(tovDatumiFilterValue).length!==0?<><Text>Datum stavljanja u tov</Text><Spacer/><CheckIcon /></>:<Text>Datum stavljanja u tov</Text>}
                      </MenuItem>
                      <MenuItem fontSize={'xs'} onClick={()=>{showFilter(RegistarFilterTypes.RodDatumi)}}>
                        {Object.getOwnPropertyNames(rodDatumiFilterValue).length!==0?<><Text>Datum rođenja</Text><Spacer/><CheckIcon /></>:<Text>Datum rođenja</Text>}
                      </MenuItem>
                      <MenuItem fontSize={'xs'} onClick={()=>{showFilter(RegistarFilterTypes.Spol)}}>
                        {spolFilterValue!==""?<><Text>Spol</Text><Spacer/><CheckIcon /></>:<Text>Spol</Text>}
                      </MenuItem>
                      <MenuItem fontSize={'xs'} onClick={()=>{showFilter(RegistarFilterTypes.Lokacije)}}>
                      {selectedlokacije.length===0?<Text>Lokacije</Text>:<><Text>Lokacije</Text><Spacer/><CheckIcon/></>}
                      </MenuItem>
                      <MenuItem fontSize={'xs'} onClick={()=>{showFilter(RegistarFilterTypes.Pasmine)}}>
                      {selectedpasmine.length===0?<Text>Pasmine</Text>:<><Text>Pasmine</Text><Spacer/><CheckIcon/></>}
                      </MenuItem>
                      <Divider/>
                      <MenuItem fontSize={'xs'} onClick={()=>{showFilter(RegistarFilterTypes.BrzaPretraga)}} icon={<SearchIcon/>}>
                        Brza pretraga - postavke
                      </MenuItem>
                    </MenuList>
                  </Portal>
              </Menu>
              <Tooltip label={'Aktivni filteri'}>
                  <IconButton ml={'0.5rem'} onClick={()=>{setFilter({...filter,filterInfoShow:true})}} key={'btnFilterOff'} variant={'outline'} colorScheme={'grunt2'} aria-label='Napredno filtriranje' icon={<MdInfo/>} size={'xs'}/>
              </Tooltip>
                <Tooltip label={'Ukloni filtere'}>
                  <IconButton ml={'0.5rem'} onClick={resetFilterAll} key={'btnFilterOff'} variant={'outline'} colorScheme={'grunt2'} isDisabled={filter.filterActive===false & selectedknjige.length===0 & selectedposjednici.length===0} aria-label='Reset filtera' icon={<MdFilterAltOff/>} size={'xs'}/>
                </Tooltip>

                <Spacer/>
                <Menu>
                <Tooltip label={'Ispiši filtrirano'} placement="top">
                <MenuButton
                      as={IconButton}
                      aria-label='Options'
                      icon={<MdPrint/>}
                      colorScheme={'grunt2'}
                      size={'xs'} variant={'outline'}
                      ml={'4rem'}
                      isLoading={ispis.izvj==="fip1" || ispis.izvj==="fip2"}
                    />
                  </Tooltip>
                  <Portal>
                    <MenuList zIndex={1400}>
                      <MenuItem  fontSize={'xs'} onClick={()=>{setIspis({...ispis,izvj:"fip1"});setFilter({...filter,toggleFetchData:!filter.toggleFetchData})}} key={'btnPrint1'} icon={<Icon as={MdOutlineArticle} boxSize={4}/>}>
                        {process.env.REACT_APP_REP1_NAME}
                      </MenuItem>
                      <MenuItem fontSize={'xs'} onClick={()=>{setIspis({...ispis,izvj:"fip2"});setFilter({...filter,toggleFetchData:!filter.toggleFetchData})}} key={'btnPrint2'} icon={<Icon as={MdOutlineArticle} boxSize={4}/>}>
                        {process.env.REACT_APP_REP2_NAME}
                      </MenuItem>
                    </MenuList>
                  </Portal>
                </Menu>
                <Tooltip label={'Izvezi u Excel'}>
                  <IconButton isLoading={ispis.izvj==="fipxlsx"} ml={'0.5rem'} onClick={()=>{setIspis({...ispis,izvj:"fipxlsx"});setFilter({...filter,toggleFetchData:!filter.toggleFetchData})}} key={'btnExcel'} variant={'outline'} colorScheme={'grunt2'}  aria-label='Ispis' icon={<RiFileExcel2Fill/>} size={'xs'}/>
                </Tooltip>
                
                {/* <Tooltip label={'Ispiši registar goveda na gospodarstvu'} placement={'left'}>
                  <IconButton isDisabled mr={'1.5rem'} isLoading={ispis.izvj==="rgg"} ml={'2rem'} onClick={()=>setRegistarIspisFilterState({...RegistarIspisFilterState,showFilterIspis:true})} key={'prntrgg'} variant={'solid'} colorScheme={'grunt2'} aria-label="Ispis registra" icon={<MdPrint/>} size={'xs'}/>
                </Tooltip> */}
                
    </Box>
    <Box display={'flex'} flexDir={'column'} flex={1} minH={0} overflow="hidden">
     {showData()}
     {filterInfoShow()}
    {showSelectedMigracija()}
    {getKnjigeFilter()}
    {getFilterControl()}
    {showGovedoForEdit()}
    {showErr()} 
    {showInfo()}
    </Box>
</Box>
  )
}
